import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  lazy,
  Suspense,
} from 'react';


import {
  Box,
  Button,
  Input,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Select,
  Text,
  Grid,
  useToast,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Spinner,
  HStack,
  Checkbox,
  Tag,
} from '@chakra-ui/react';
import { Bar } from 'react-chartjs-2';
import { Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import { AddIcon, ChevronDownIcon } from '@chakra-ui/icons';
import * as XLSX from 'xlsx';
import axios from 'axios';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
} from 'chart.js';
import TransaccionDetails from 'views/Pagos/DetallePagos';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import LoadingOverlay from 'components/cargando/loading';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  ChartDataLabels,
);

const CajaGeneral = lazy(() => import('../Facturacion/CajaGeneral')); // Lazy load del componente

interface Transaccion {
  usuario: string;
  ID: number;
  Concepto: string;
  RazonSocial: string;
  MetodoPago: string;
  Monto: number | null;
  UUID: string;
  RFCReceptor: string;
  estatus_de_cancelacion: string;
  procedencia: string | null;
  Fecha: string;
  IDTransacc: string;
  localidad: string | null;
  idLocalidad: number | null;
}

const HistorialTransacciones: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  //const userProfile = user?.rol || 'guest'; // Perfil del usuario actual
  const [FilteredTransactions, setFilteredTransactions] = useState<
    Transaccion[]
  >([]);

  const today = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }); // Ejemplo: "December 7, 2024"
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1); // Sumar 1 día
  const formattedTomorrow = tomorrow.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  //const [estatusFilter, setEstatusFilter] = useState(false);
  const [estatusFilter, setEstatusFilter] = useState('TODOS'); // Estado del filtro

  const [razonSocialFilterx, setRazonSocialFilterx] = useState('');
  const [usuarioFilterx, setusuarioFilterx] = useState('');
  const [localidadFilter, setLocalidadFilter] = useState('');
  const [tipoTransaccionFilter, setTipoTransaccionFilter] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [transactions, setTransactions] = useState<Transaccion[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10000);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [conceptoFilter, setConceptoFilter] = useState('');
  const [razonSocialFilter, setRazonSocialFilter] = useState('');
  const [metodoPagoFilter, setMetodoPagoFilter] = useState('');
  const [startDate, setStartDate] = useState(today);
  const [loading, setLoading] = useState(false); // Estado para bloquear pantalla

  const [endDate, setEndDate] = useState(formattedTomorrow);

  const [selectedTransaction, setSelectedTransaction] =
    useState<Transaccion | null>(null);

  const toast = useToast();
  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onClose: onModalClose,
  } = useDisclosure();
  const {
    isOpen: isDetailOpen,
    onOpen: onDetailOpen,
    onClose: onDetailClose,
  } = useDisclosure();

  const fetchTransactions = useCallback(async () => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        search: searchTerm,
        concepto: conceptoFilter,
        razonSocial: razonSocialFilter,
        metodoPago: metodoPagoFilter,
        startDate,
        endDate,
        Concepto:'AGUA POTABLE'
      });

      setIsLoading(true);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/Transacciones?${params.toString()}`,
      );
      const data = await response.json();
      //const data = await response.json();
      const filteredData = data.data.filter(
        (transaction: Transaccion) => transaction.Concepto === 'AGUA POTABLE',
      );
      setTransactions(filteredData);
      //setTransactions(data.data);
      setTotalPages(data.pagination.totalPages);

      setIsLoading(false);

    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudieron cargar los datos de las transacciones.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }, [
    page,
    pageSize,
    searchTerm,
    conceptoFilter,
    razonSocialFilter,
    metodoPagoFilter,
    startDate,
    endDate,
  ]);

  useEffect(() => {
    fetchTransactions();
  }, []);

  useEffect(() => {
    const filteredData = transactions.filter((transaction) => {
      const matchesRazonSocial = transaction.RazonSocial.toLowerCase().includes(
        razonSocialFilterx.toLowerCase(),
      );
      const matchesUsuario = transaction.usuario
        .toLowerCase()
        .includes(usuarioFilterx.toLowerCase());

      const matchesLocalidad =
        localidadFilter === ''
          ? true
          : (transaction.localidad || '').toLowerCase() === localidadFilter.toLowerCase();

      const matchesTipoTransaccion =
        tipoTransaccionFilter === ''
          ? true
          : tipoTransaccionFilter === 'CAJA'
          ? !(transaction.procedencia || '').toUpperCase().includes('OPENPAY')
          : (transaction.procedencia || '').toUpperCase().includes('OPENPAY');

      const matchesEstatus =
        estatusFilter === 'TODOS'
          ? true // TODOS incluye todos los registros
          : estatusFilter === 'CANCELADO'
          ? transaction.estatus_de_cancelacion === 'CANCELADO' // Solo cancelados
          : estatusFilter === 'TIMBRADOS'
          ? transaction.estatus_de_cancelacion !== 'CANCELADO' //&& transaction.estatus_de_cancelacion === '' // Solo vacíos sin "CANCELADO"
          : true;
      return matchesRazonSocial && matchesUsuario && matchesEstatus && matchesLocalidad && matchesTipoTransaccion;
    });

    //return matchesRazonSocial && matchesEstatus;
    /// });

    setFilteredTransactions(filteredData);
    //setFilteredTransactions(filteredData);
  }, [razonSocialFilterx, usuarioFilterx, estatusFilter, localidadFilter, tipoTransaccionFilter, transactions]);

  const applyFilters = useCallback(() => {
    setPage(1); // Reiniciar a la primera página al aplicar filtros
     fetchTransactions();
  }, [fetchTransactions]);

  const paginatedTransactions = useMemo(() => {
    const startIndex = (page - 1) * pageSize;
    return transactions.slice(startIndex, startIndex + pageSize);
  }, [page, pageSize, transactions]);

  // Obtener localidades únicas para el filtro
  const localidadesUnicas = useMemo(() => {
    const localidades = transactions
      .map((t) => t.localidad)
      .filter((loc): loc is string => loc !== null && loc !== undefined && loc !== '');
    return [...new Set(localidades)].sort();
  }, [transactions]);

  const groupedData = useMemo(() => {
    return FilteredTransactions.reduce((acc, transaction) => {
      if (transaction.Concepto in acc) {
        acc[transaction.Concepto] += transaction.Monto || 0;
      } else {
        acc[transaction.Concepto] = transaction.Monto || 0;
      }
      return acc;
    }, {} as Record<string, number>);
  }, [FilteredTransactions]);

  const chartOptions = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        datalabels: {
          formatter: (value: number) => `$${value.toFixed(2)}`,
          font: {
            size: 12,
          },
          color: 'black',
        },
      },
    }),
    [],
  );

  const chartData = useMemo(() => {
    return {
      labels: Object.keys(groupedData),
      datasets: [
        {
          label: 'Transacciones de Agua Potable',
          data: Object.values(groupedData),
          backgroundColor: 'rgba(75, 192, 192, 0.6)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 1,
        },
      ],
    };
  }, [groupedData]);

  const handleViewDetails = useCallback(
    (transaction: Transaccion) => {
      setSelectedTransaction(transaction);
      onDetailOpen();
    },
    [onDetailOpen],
  );

  const downloadExcel = useCallback(() => {
    const ws = XLSX.utils.json_to_sheet(transactions);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Transacciones');
    XLSX.writeFile(wb, 'transacciones.xlsx');
  }, [transactions]);

  return (
    <Box p={5} pt={79}>
            <LoadingOverlay isLoading={isLoading} message="Procesando..." />

      {loading && (
        <Box
          position="fixed"
          top="0"
          left="0"
          width="100vw"
          height="100vh"
          bg="rgba(0, 0, 0, 0.5)"
          display="flex"
          justifyContent="center"
          alignItems="center"
          zIndex="9999"
        >
          <Spinner size="xl" color="white" />
        </Box>
      )}
    
      {/* Gráfica */}
      <Box
        mb={6}
        style={{
          maxWidth: '600px',
          maxHeight: '400px',
          margin: '0 auto',
        }}
      >
        <Bar data={chartData} options={chartOptions} />
      </Box>

      {/* Filtros y Acciones */}
      <Flex justifyContent="space-between" mb={2}>
        <Grid templateColumns="repeat(6, 1fr)" gap={1}>
          <Input
            placeholder="Filtrar por Razon Social"
            value={razonSocialFilterx}
            maxW={'780px'}
            onChange={(e) => setRazonSocialFilterx(e.target.value)} // Actualiza el estado al escribir
            focusBorderColor="teal.400" // Color del borde cuando está enfocado
            size="md" // Tamaño del input
            variant="outline" // Estilo del input
          />

          <Input
            placeholder="Filtrar por Nombre de Usuario"
            value={usuarioFilterx}
            maxW={'480px'}
            onChange={(e) => setusuarioFilterx(e.target.value)} // Actualiza el estado al escribir
            focusBorderColor="teal.400" // Color del borde cuando está enfocado
            size="md" // Tamaño del input
            variant="outline" // Estilo del input
          />
          {/* Checkbox controlado */}
          <Select
            placeholder="Selecciona un estatus"
            value={estatusFilter} // Valor actual del filtro
            onChange={(e) => setEstatusFilter(e.target.value)} // Actualiza el estado al cambiar
            colorScheme="teal"
            size="md"
            maxW="320px"
          >
            <option value="">Todos</option>
            <option value="CANCELADO">Cancelados</option>
            <option value="TIMBRADOS">Timbrados</option>
          </Select>

          <Select
            placeholder="Filtrar por Localidad"
            value={localidadFilter}
            onChange={(e) => setLocalidadFilter(e.target.value)}
            colorScheme="teal"
            size="md"
            maxW="320px"
          >
            <option value="">Todas las localidades</option>
            {localidadesUnicas.map((localidad) => (
              <option key={localidad} value={localidad}>
                {localidad}
              </option>
            ))}
          </Select>

          <Select
            placeholder="Tipo de Transacción"
            value={tipoTransaccionFilter}
            onChange={(e) => setTipoTransaccionFilter(e.target.value)}
            colorScheme="teal"
            size="md"
            maxW="320px"
          >
            <option value="">Todas</option>
            <option value="CAJA">Caja</option>
            <option value="LINEA">En línea</option>
          </Select>

          <Input
            type="date"
            placeholder="Desde"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <Input
            type="date"
            placeholder="Hasta"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <Button bg="#5b182b" color="white" _hover={{ bg: "#691f30" }} onClick={applyFilters}>
    Aplicar Filtros
  </Button>
        </Grid>
        <HStack spacing={4}>
          <Menu>
            {user.rol == 'AXXXXXX' && (
              <MenuButton
                as={Button}
                rightIcon={<ChevronDownIcon />}
                bg="#bb8c52" color="white" _hover={{ bg: "#a67a47" }}
              >
                Reportes DEV
              </MenuButton>
            )}
            <MenuList zIndex={9999}>
              {/* <MenuItem onClick={onModalOpen}>Nuevo</MenuItem> */}

              {user.rol == 'A1' && (
                <MenuItem
                  onClick={async () => {
                    if (!startDate || !endDate) {
                      toast({
                        title: 'Error',
                        description: 'Por favor, selecciona ambas fechas.',
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                      });
                      return;
                    }

                    try {
                      const response = await axios.get(
                        `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/ReportesRoutes/reporte-financiero-agua?startDate=${startDate}&endDate=${endDate}`,
                        { responseType: 'blob' },
                      );

                      const url = window.URL.createObjectURL(
                        new Blob([response.data]),
                      );
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute(
                        'download',
                        `reporte-financiero-${startDate}-${endDate}.pdf`,
                      );
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);

                      toast({
                        title: 'Éxito',
                        description:
                          'Reporte financiero generado correctamente.',
                        status: 'success',
                        duration: 5000,
                        isClosable: true,
                      });
                    } catch (error) {
                      console.error(
                        'Error al generar el reporte financiero:',
                        error,
                      );
                      toast({
                        title: 'Error',
                        description:
                          'No se pudo generar el reporte financiero. Intenta de nuevo.',
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                      });
                    }
                  }}
                >
                  Generar Reporte
                </MenuItem>
              )}
              {user.rol == 'A1' && (
                <MenuItem
                  onClick={async () => {
                    if (!startDate || !endDate) {
                      toast({
                        title: 'Error',
                        description: 'Por favor, selecciona ambas fechas.',
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                      });
                      return;
                    }

                    try {
                      const response = await axios.get(
                        `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/ReportesRoutes/reporte-financiero-agua-cancelados?startDate=${startDate}&endDate=${endDate}`,
                        { responseType: 'blob' },
                      );

                      const url = window.URL.createObjectURL(
                        new Blob([response.data]),
                      );
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute(
                        'download',
                        `reporte-financiero-cancelacion${startDate}-${endDate}.pdf`,
                      );
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);

                      toast({
                        title: 'Éxito',
                        description:
                          'Reporte financiero generado correctamente.',
                        status: 'success',
                        duration: 5000,
                        isClosable: true,
                      });
                    } catch (error) {
                      console.error(
                        'Error al generar el reporte financiero:',
                        error,
                      );
                      toast({
                        title: 'Error',
                        description:
                          'No se pudo generar el reporte financiero. Intenta de nuevo.',
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                      });
                    }
                  }}
                >
                  Generar Reporte de Cancelacion
                </MenuItem>
              )}

              <MenuItem onClick={downloadExcel}>Descargar XLS</MenuItem>
            </MenuList>
          </Menu>
        </HStack>

        <HStack spacing={4}>
          <Menu>
            {user.rol == 'A1' && (
              <MenuButton
                as={Button}
                rightIcon={<ChevronDownIcon />}
                bg="#bb8c52" color="white" _hover={{ bg: "#a67a47" }}
              >
                Reportes
              </MenuButton>
            )}
            <MenuList zIndex={9999}>
              {/* <MenuItem onClick={onModalOpen}>Nuevo</MenuItem> */}

              {user.rol == 'A1' && (
                <MenuItem
                  onClick={async () => {
                    if (!startDate || !endDate) {
                      toast({
                        title: 'Error',
                        description: 'Por favor, selecciona ambas fechas.',
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                      });
                      return;
                    }

                    try {
                      const response = await axios.get(
                        `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/ReportesRoutes/reporte-financiero-agua?startDate=${startDate}&endDate=${endDate}`,
                        { responseType: 'blob' },
                      );

                      const url = window.URL.createObjectURL(
                        new Blob([response.data]),
                      );
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute(
                        'download',
                        `reporte-financiero-${startDate}-${endDate}.pdf`,
                      );
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);

                      toast({
                        title: 'Éxito',
                        description:
                          'Reporte financiero generado correctamente.',
                        status: 'success',
                        duration: 5000,
                        isClosable: true,
                      });
                    } catch (error) {
                      console.error(
                        'Error al generar el reporte financiero:',
                        error,
                      );
                      toast({
                        title: 'Error',
                        description:
                          'No se pudo generar el reporte financiero. Intenta de nuevo.',
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                      });
                    }
                  }}
                >
                  Generar Reporte
                </MenuItem>
              )}
              {user.rol == 'A1' && (
                <MenuItem
                  onClick={async () => {
                    if (!startDate || !endDate) {
                      toast({
                        title: 'Error',
                        description: 'Por favor, selecciona ambas fechas.',
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                      });
                      return;
                    }

                    try {
                      const response = await axios.get(
                        `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/ReportesRoutes/reporte-financiero-agua-cancelados?startDate=${startDate}&endDate=${endDate}`,
                        { responseType: 'blob' },
                      );

                      const url = window.URL.createObjectURL(
                        new Blob([response.data]),
                      );
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute(
                        'download',
                        `reporte-financiero-cancelacion${startDate}-${endDate}.pdf`,
                      );
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);

                      toast({
                        title: 'Éxito',
                        description:
                          'Reporte financiero generado correctamente.',
                        status: 'success',
                        duration: 5000,
                        isClosable: true,
                      });
                    } catch (error) {
                      console.error(
                        'Error al generar el reporte financiero:',
                        error,
                      );
                      toast({
                        title: 'Error',
                        description:
                          'No se pudo generar el reporte financiero. Intenta de nuevo.',
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                      });
                    }
                  }}
                >
                  Generar Reporte de Cancelacion
                </MenuItem>
              )}
              {user.rol == 'A1' && (
                <MenuItem
                  onClick={async () => {
                    if (!startDate || !endDate) {
                      toast({
                        title: 'Error',
                        description: 'Por favor, selecciona ambas fechas.',
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                      });
                      return;
                    }

                    try {
                      const response = await axios.get(
                        `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/ReportesRoutes/reporte-recaudo-agua-pdf?startDate=${startDate}&endDate=${endDate}`,
                        { responseType: 'blob' },
                      );

                      const url = window.URL.createObjectURL(
                        new Blob([response.data]),
                      );
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute(
                        'download',
                        `reporte-recaudacion-agua-${startDate}-${endDate}.pdf`,
                      );
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);

                      toast({
                        title: 'Éxito',
                        description:
                          'Reporte de recaudación generado correctamente.',
                        status: 'success',
                        duration: 5000,
                        isClosable: true,
                      });
                    } catch (error) {
                      console.error(
                        'Error al generar el reporte de recaudación:',
                        error,
                      );
                      toast({
                        title: 'Error',
                        description:
                          'No se pudo generar el reporte de recaudación. Intenta de nuevo.',
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                      });
                    }
                  }}
                >
                  Reporte Detallado de Recaudación
                </MenuItem>
              )}

              <MenuItem onClick={downloadExcel}>Descargar XLS</MenuItem>
            </MenuList>
          </Menu>
        </HStack>
      </Flex>

      {/* Tabla de Transacciones */}
      <Box
        overflowY="auto"
        maxH="580px"
        borderRadius="lg"
        boxShadow="lg"
        bg="white"
        border="1px solid"
        borderColor="gray.200"
      >
        <Table variant="simple" size="sm" style={{ tableLayout: 'fixed', width: '100%' }}>
          <Thead
            position="sticky"
            top={0}
            bg="linear-gradient(135deg, #0d9488 0%, #06b6d4 100%)"
            zIndex={1}
          >
            <Tr>
              <Th color="white" fontSize="xs" textTransform="uppercase" py={4} width="50px">ID</Th>
              <Th color="white" fontSize="xs" textTransform="uppercase" py={4} width="100px">Identificador</Th>
              <Th color="white" fontSize="xs" textTransform="uppercase" py={4} width="100px">Concepto</Th>
              <Th color="white" fontSize="xs" textTransform="uppercase" py={4} width="180px">Razón Social</Th>
              <Th color="white" fontSize="xs" textTransform="uppercase" py={4} width="100px">Método de Pago</Th>
              <Th color="white" fontSize="xs" textTransform="uppercase" py={4} width="90px">Estatus</Th>
              <Th color="white" fontSize="xs" textTransform="uppercase" py={4} width="90px" isNumeric>Monto</Th>
              <Th color="white" fontSize="xs" textTransform="uppercase" py={4} width="90px">Fecha</Th>
              <Th color="white" fontSize="xs" textTransform="uppercase" py={4} width="100px">Localidad</Th>
              <Th color="white" fontSize="xs" textTransform="uppercase" py={4} width="90px">Usuario</Th>
              <Th color="white" fontSize="xs" textTransform="uppercase" py={4} width="100px">Acciones</Th>
            </Tr>
          </Thead>
          <Tbody>
            {FilteredTransactions.map((transaction, index) => (
              <Tr
                key={transaction.ID}
                bgColor={
                  transaction.estatus_de_cancelacion === 'CANCELADO'
                    ? 'red.50'
                    : index % 2 === 0
                    ? 'gray.50'
                    : 'white'
                }
                _hover={{
                  bg: transaction.estatus_de_cancelacion === 'CANCELADO' ? 'red.100' : '#e0f2f1',
                  transition: 'background 0.2s',
                }}
                borderBottom="1px solid"
                borderColor="gray.200"
              >
                <Td fontWeight="medium" color="gray.700">
                  <Text fontSize="sm">#{transaction.ID}</Text>
                </Td>
                <Td>
                  <Text
                    fontWeight="bold"
                    color="teal.600"
                    fontSize="sm"
                    px={2}
                    py={1}
                    bg="teal.50"
                    borderRadius="md"
                    display="inline-block"
                  >
                    {transaction.IDTransacc || 'N/A'}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" fontWeight="medium" color="gray.800">
                    {transaction.Concepto}
                  </Text>
                </Td>
                <Td overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
                  <Text fontSize="sm" color="gray.700" noOfLines={1} title={transaction.RazonSocial}>
                    {transaction.RazonSocial}
                  </Text>
                </Td>
                <Td>
                  <Box
                    as="span"
                    px={3}
                    py={1}
                    bg="#0d9488"
                    color="white"
                    borderRadius="full"
                    fontSize="xs"
                    fontWeight="bold"
                    display="inline-block"
                  >
                    {transaction.MetodoPago}
                  </Box>
                </Td>
                <Td>
                  <Box
                    as="span"
                    px={3}
                    py={1}
                    bg={transaction.estatus_de_cancelacion === 'CANCELADO' ? '#dc2626' : '#16a34a'}
                    color="white"
                    borderRadius="full"
                    fontSize="xs"
                    fontWeight="bold"
                    display="inline-block"
                  >
                    {transaction.estatus_de_cancelacion === 'CANCELADO' ? '✗ CANCELADO' : '✓ ACTIVO'}
                  </Box>
                </Td>
                <Td isNumeric>
                  <Text
                    fontSize="sm"
                    fontWeight="bold"
                    color={transaction.Monto && transaction.Monto > 0 ? 'green.600' : 'gray.500'}
                  >
                    {transaction.Monto !== null
                      ? `$${transaction.Monto.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                      : 'N/A'}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="xs" color="gray.600">
                    {new Date(transaction.Fecha).toLocaleDateString('es-MX', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric'
                    })}
                  </Text>
                  <Text fontSize="xs" color="gray.500">
                    {new Date(transaction.Fecha).toLocaleTimeString('es-MX', {
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </Text>
                </Td>
                  <Td>
                  <Text fontSize="xs" color="gray.600" fontWeight="medium">
                    {transaction.localidad || 'N/A'}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="xs" color="gray.600" fontWeight="medium">
                    {transaction.usuario}
                  </Text>
                </Td>
              
                <Td>
                  <Menu>
                    <MenuButton
                      as={Button}
                      size="sm"
                      rightIcon={<ChevronDownIcon />}
                      bg="#0d9488"
                      color="white"
                      _hover={{ bg: "#0f766e" }}
                      _active={{ bg: "#115e59" }}
                    >
                      Acciones
                    </MenuButton>
                    <MenuList zIndex={9999}>
                      <MenuItem onClick={() => handleViewDetails(transaction)}>
                        Ver Detalles
                      </MenuItem>
                      <MenuItem
  onClick={() => {
    const downloadUrl = `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/Facturacion/descargar/${transaction.UUID}`;
    window.open(downloadUrl, '_blank');
  }}
>
  Descargar XML
</MenuItem>

                      <MenuItem
                        onClick={async () => {
                          let toastId; // Identificador para el toast
                          try {
                            // Mostrar un toast indicando que se está procesando la cancelación
                            toastId = toast({
                              title: 'Procesando',
                              description:
                                'La cancelación del CFDI está en curso, espera un momento.',
                              status: 'info',
                              duration: null, // El toast permanece visible hasta que lo cierres manualmente
                              isClosable: true,
                            });

                            // Datos requeridos por el backend
                            const requestData = {
                              user: 'usuario_desde_bd',
                              pass: 'password_desde_bd',
                              rfcEmisor: 'RFC_desde_bd',
                              listaCFDI: [
                                {
                                  EsCancelable: true, // Supón que el CFDI es cancelable
                                  FolioSustitucion: '', // Si aplica, puedes incluirlo
                                  Motivo: '03', // Motivo de cancelación: "No se llevó a cabo la operación"
                                  RFCReceptor:
                                    transaction.RFCReceptor || 'XAXX010101000',
                                  Total: transaction.Monto,
                                  UUID: transaction.UUID, // UUID del CFDI que se desea cancelar
                                },
                              ],
                            };

                            // Realizar la solicitud POST al backend
                            const response = await axios.post(
                              `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/Facturacion/cancelar-cfdi`,
                              requestData,
                              { responseType: 'blob' }, // Asegúrate de recibir el archivo como blob
                            );

                            if (response.data) {
                              // Crear un blob a partir del XML
                              const xmlBlob = new Blob([response.data], {
                                type: 'application/xml',
                              });

                              // Crear un enlace para descargar el archivo
                              const xmlUrl = URL.createObjectURL(xmlBlob);
                              const link = document.createElement('a');
                              link.href = xmlUrl;
                              link.setAttribute(
                                'download',
                                `Cancelacion_CFDI_${transaction.UUID}.xml`,
                              );

                              // Simular clic en el enlace para iniciar la descarga
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);

                              // Cerrar el toast de progreso y mostrar uno de éxito
                              toast.close(toastId);
                              toast({
                                title: 'Éxito',
                                description:
                                  'El CFDI fue cancelado y el XML se descargó correctamente.',
                                status: 'success',
                                duration: 5000,
                                isClosable: true,
                              });
                            } else {
                              // Cerrar el toast de progreso y mostrar uno de error
                              toast.close(toastId);
                              toast({
                                title: 'Error',
                                description:
                                  'No se pudo cancelar el CFDI. Intenta de nuevo.',
                                status: 'error',
                                duration: 5000,
                                isClosable: true,
                              });
                            }
                          } catch (error) {
                            console.error('Error al cancelar el CFDI:', error);

                            // Cerrar el toast de progreso y mostrar uno de error
                            toast.close(toastId);
                            toast({
                              title: 'Error',
                              description:
                                'No se pudo cancelar el CFDI. Intenta de nuevo.',
                              status: 'error',
                              duration: 5000,
                              isClosable: true,
                            });
                          }
                        }}
                      >
                        Cancelar CFDI
                      </MenuItem>
                      <MenuItem
                        onClick={async () => {
                          setLoading(true); // Activa el bloqueo de pantalla

                          try {
                            const response = await axios.get(
                              `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/Transacciones/ImprimirAgua/` +
                                transaction.ID,
                              {
                                responseType: 'blob',
                              },
                            );

                            const pdfBlob = new Blob([response.data], {
                              type: 'application/pdf',
                            });
                            const pdfUrl = URL.createObjectURL(pdfBlob);

                            // const link = document.createElement('a');
                            // link.href = pdfUrl;
                            // link.setAttribute(
                            //   'download',
                            //   `CFDI_${transaction.ID}.pdf`,
                            // );
                            // document.body.appendChild(link);
                            // link.click();
                            // document.body.removeChild(link);

                            window.open(pdfUrl, '_blank');

                            toast({
                              title: 'Éxito',
                              description: 'CFDI descargado correctamente.',
                              status: 'success',
                              duration: 5000,
                              isClosable: true,
                            });
                          } catch (error) {
                            console.error('Error al descargar el CFDI:', error);
                            toast({
                              title: 'Error',
                              description:
                                'No se pudo descargar el CFDI. Intenta de nuevo.',
                              status: 'error',
                              duration: 5000,
                              isClosable: true,
                            });
                          } finally {
                            setLoading(false);
                          }
                        }}
                      >
                        Imprimir CFDI
                      </MenuItem>{' '}
                    </MenuList>
                  </Menu>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      {/* Paginación */}
      <Flex justifyContent="space-between" mt={4}>
        <Button
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          isDisabled={page === 1}
        >
          Anterior
        </Button>
        <Text>
          Página {page} de {totalPages}
        </Text>
        <Button
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          isDisabled={page === totalPages}
        >
          Siguiente
        </Button>
      </Flex>

      {/* Modal para CajaGeneral */}
      <Modal isOpen={isModalOpen} onClose={onModalClose} size="full">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Nueva Transacción</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Suspense fallback={<Spinner />}>
              <CajaGeneral />
            </Suspense>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Modal para Ver Detalles */}
      <Modal isOpen={isDetailOpen} onClose={onDetailClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Detalles de Transacción</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <ModalBody>
              {selectedTransaction && (
                <TransaccionDetails
                  transaccionId={selectedTransaction.ID.toString()}
                />
              )}
            </ModalBody>
          </ModalBody>
        </ModalContent>
      </Modal>


    </Box>
  );
};

export default HistorialTransacciones;
